import React from 'react'
import UserInfo from '../Components/UserInfo'

function UserAccountInfo() {
  return (
    <div>
        <UserInfo/>
    </div>
  )
}

export default UserAccountInfo